<template>
  <div class="event-page">
    <div
      v-if="loading"
      class="loader-container"
    >
      <!-- <q-spinner-ios color="primary" size="10em" /> -->
    </div>
    <!-- выбор животного -->
    <template v-else-if="step === 1">
      <div class="event-page__main">
        <h2 class="event-page__title">
          {{ t('eventsWizard.choosePet') }}
        </h2>
        <div
          v-if="!animals?.length"
          class="event-page__empty"
        >
          {{ t('eventsWizard.noPets') }}
        </div>
        <div
          v-else
          class="event-page__pets"
        >
          <div
            v-for="item in animals "
            :key="item.id"
            class="event-page__pets-item"
            :class="{ active: servey.choosedPetId === item.id }"
            @click="servey.choosedPetId = item.id"
          >
            <img
              v-if="item.payload?.photos[0]?.path"
              :src="item.payload?.photos[0]?.path"
              class="event-page__pets-img"
            >
            <IconBase
              v-else
              :path="`animals/${getAnimalById(item?.payload?.animal_id || item?.animal_id).icon}.svg`"
              class="event-page__pets-img"
            />
            <div class="event-page__pets-body">
              <div class="event-page__pets-name">
                {{ item.payload?.name }}
              </div>
              <div class="event-page__pets-breed">
                {{ item.payload?.breed }}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="footer">
        <ButtonBase
          v-if="!animals?.length"
          @click="$router.push('/pet-create')"
        >
          {{ t('eventsWizard.addPet') }}
        </ButtonBase>
        <ButtonBase
          v-else
          :class="{ hidden: !servey.choosedPetId }"
          @click="step++"
        >
          {{ t('common.next') }}
        </ButtonBase>
        <ButtonBase
          variant="text"
          class="ui-btn default"
          @click="$router.back()"
        >
          {{ t('common.back') }}
        </ButtonBase>
      </div>
    </template>

    <!-- название события -->
    <template v-else-if="step === 2">
      <div class="event-page__main">
        <h2 class="event-page__title">
          {{ t('eventsWizard.title') }}
        </h2>
        <InputSimple
          v-model="servey.title"
          class="mb"
          :placeholder="t('eventsWizard.titlePlaceholder')"
          big
        />
        <TextareaBase
          v-model="servey.description"
          :placeholder="t('eventsWizard.descriptionPlaceholder')"
          big
        />
      </div>
      <div class="footer">
        <ButtonBase
          :class="{ hidden: !servey.title }"
          @click="step++"
        >
          {{ t('common.next') }}
        </ButtonBase>
        <ButtonBase
          variant="text"
          class="ui-btn default"
          @click="
            step--;
            servey.title = '';
            servey.description = '';
          "
        >
          {{ t('common.back') }}
        </ButtonBase>
      </div>
    </template>

    <!-- повторение события? -->
    <template v-else-if="step === 3">
      <div class="event-page__main">
        <h2 class="event-page__title">
          {{ t('eventsWizard.repeatQuestion') }}
        </h2>
        <CheckboxTabs
          v-model="servey.optionForRepeatEventStep"
          :options="optionsForRepeatEventStep"
          class="mb-20"
        />
        <template v-if="servey.optionForRepeatEventStep == 1">
          <div
            class="event-page__date-wrapp"
            :class="{ choosed: servey.choosedDate?.title }"
            @click="openDatePicker"
          >
            <div
              class="event-page__date-text"
              :class="{ choosed: servey.choosedDate?.title }"
            >
              {{
                servey.choosedDate?.title
                  ? servey.choosedDate?.title
                  : t('eventsWizard.chooseDate')
              }}
            </div>
            <img
              src="./assets/calendar.svg"
              :class="{ choosed: servey.choosedDate?.title }"
              class="event-page__date-img"
            >
          </div>

          <DatePicker
            ref="DatePickerREF"
            @choose="(value) => servey.choosedDate = value"
          />
        </template>
        <template v-else>
          <div
            v-for=" item in repeatTypes "
            :key="item.value"
            class="event-page__select"
            :class="{ active: item.value === servey.optionRepeatSelected }"
            @click="servey.optionRepeatSelected = item.value"
          >
            {{ item.label }}
          </div>
        </template>
      </div>
      <div class="footer">
        <ButtonBase
          :class="{ hidden: !(servey.optionRepeatSelected || servey.choosedDate?.title) }"
          @click="
            servey.optionRepeatSelected === 3 ? (step = step + 0.3) : step++
          "
        >
          {{ t('common.next') }}
        </ButtonBase>

        <ButtonBase
          variant="text"
          class="ui-btn default"
          @click="
            step--;
            servey.choosedDate = null;
            servey.optionRepeatSelected = null;
          "
        >
          {{ t('common.back') }}
        </ButtonBase>
      </div>
    </template>

    <!-- подсобытие повторения события? -->
    <template v-else-if="step === 3.3">
      <div class="event-page__main">
        <h2 class="event-page__title">
          {{ t('eventsWizard.chooseWeekdays') }}
        </h2>

        <div
          v-for=" item in days "
          :key="item.value"
          class="event-page__select"
          :class="{ active: servey.selectedDays.includes(item.value) }"
          @click="
            servey.selectedDays.includes(item.value)
              ? (servey.selectedDays = servey.selectedDays.filter(
                (el) => el !== item.value
              ))
              : servey.selectedDays.push(item.value)
          "
        >
          {{ item.label }}
        </div>
      </div>
      <div class="footer">
        <ButtonBase
          :class="{ hidden: !servey.selectedDays.length }"
          @click="step = step + 0.7"
        >
          {{ t('common.next') }}
        </ButtonBase>

        <ButtonBase
          variant="text"
          class="ui-btn default"
          @click="
            step = step - 0.3;
            servey.selectedDays.length = 0;
          "
        >
          {{ t('common.back') }}
        </ButtonBase>
      </div>
    </template>

    <!-- выбор времени -->
    <template v-else-if="step === 4">
      <div class="event-page__main">
        <h2 class="event-page__title">
          {{ t('eventsWizard.chooseTime') }}
        </h2>
        <CheckboxTabs
          v-model="servey.selectedTimeTypes"
          :options="timeTypes"
          class="mb-20"
        />
        <template v-if="servey.selectedTimeTypes === 1">
          <div class="mb">
            <TimePicker
              id="fdts3f"
              v-model="servey.choosedTimeStart"
              :placeholder="t('eventsWizard.timeStart')"
            />
          </div>
          <TimePicker
            id="f65dsf"
            v-model="servey.choosedTimeEnd"
            :placeholder="t('eventsWizard.timeEnd')"
          />
        </template>
      </div>
      <div class="footer">
        <ButtonBase
          :class="{
            hidden: !((servey.selectedTimeTypes === 1 && servey.choosedTimeStart) ||
              servey.selectedTimeTypes !== 1)
          }"
          @click="finish"
        >
          {{ t('common.save') }}
        </ButtonBase>
        <FinishEvent
          ref="FinishREF"
          :title="servey.title"
          @new-servey="newServey"
        />

        <ButtonBase
          variant="text"
          class="ui-btn default"
          @click="
            step--;
            servey.choosedTimeStart = null;
            servey.choosedTimeEnd = null;
          "
        >
          {{ t('common.back') }}
        </ButtonBase>
      </div>
    </template>
  </div>
</template>

<script setup>
import { computed, onMounted, ref, watch } from "vue";
import { useRoute } from "vue-router";
import { useI18n } from "vue-i18n";
import { InputSimple, TextareaBase, IconBase, CheckboxTabs, ButtonBase } from '@/UI'
import { getAnimals, getEvents, createEvent, updateEvent } from './api'

import DatePicker from "./components/DatePicker.vue";
import TimePicker from "@/components/TimePicker";
import FinishEvent from "./components/FinishEvent.vue";
import { errorToast } from '@/helpers/showToast'
import { getAnimalById } from '@/helpers/helpers';

const { t } = useI18n();
const route = useRoute();
const eventId = computed(() => route.params.id ? Number(route.params.id) : null);

const DatePickerREF = ref();
const FinishREF = ref();
const animals = ref(null)

const step = ref(1);

const init = () => ({
  choosedPetId: null,

  title: "",
  description: "",

  optionRepeatSelected: null,
  optionForRepeatEventStep: 1,
  choosedDate: null,
  choosedTimeStart: '',
  choosedTimeEnd: '',
  selectedDays: [],
  selectedTimeTypes: 1,
});
const newServey = () => {
  servey.value = { ...init() };
  step.value = 1;
};
const servey = ref(init());

// const openTimePicker = async () => {
//   servey.value.choosedTimeStart = await TimePickerREF.value.openModal(
//     servey.value.choosedTimeStart
//   );
// };

// const openTimePicker2 = async () => {
//   servey.value.choosedTimeEnd = await TimePickerREF.value.openModal(
//     servey.value.choosedTimeEnd
//   );
// };
const openDatePicker = async () => {
  DatePickerREF.value.openModal();
};

const optionsForRepeatEventStep = computed(() => [
  { value: 1, label: t('eventsWizard.oneTime') },
  { value: 2, label: t('eventsWizard.recurring') },
]);
// value -> backend repeat_type; 4 ("по повторяющемуся циклу") has no interval-input UI yet,
// so it's stored as a tag only and does not generate future occurrences (see backend model.create)
const repeatTypes = computed(() => [
  { value: 1, label: t('eventsWizard.repeatEveryDay'), repeatType: 'day' },
  { value: 2, label: t('eventsWizard.repeatEveryOtherDay'), repeatType: 'day' },
  { value: 3, label: t('eventsWizard.repeatCustomDays'), repeatType: 'custom_days' },
  { value: 4, label: t('eventsWizard.repeatCycle'), repeatType: 'month' },
]);
const days = computed(() => [
  { value: 0, label: t('eventsWizard.monday') },
  { value: 1, label: t('eventsWizard.tuesday') },
  { value: 2, label: t('eventsWizard.wednesday') },
  { value: 3, label: t('eventsWizard.thursday') },
  { value: 4, label: t('eventsWizard.friday') },
  { value: 5, label: t('eventsWizard.saturday') },
  { value: 6, label: t('eventsWizard.sunday') },
]);
const timeTypes = computed(() => [
  { value: 1, label: t('eventsWizard.atTime') },
  { value: 2, label: t('eventsWizard.allDay') },
]);

watch(
  () => servey.value.optionForRepeatEventStep,
  () => {
    servey.value.choosedDate = null;
    servey.value.optionRepeatSelected = null;
  }
);

watch(
  () => servey.value.selectedTimeTypes,
  () => {
    servey.value.choosedTimeStart = null;
    servey.value.choosedTimeEnd = null;
  }
);

// const animalsStore = useAnimalsStore();

//step 2

defineEmits(["mounted"]);
const loading = ref(true);

const buildDate = () => {
  const base = servey.value.choosedDate?.date
    ? new Date(servey.value.choosedDate.date)
    : new Date();

  if (servey.value.selectedTimeTypes === 1 && servey.value.choosedTimeStart) {
    const [hours, minutes] = servey.value.choosedTimeStart.split(':').map(Number);
    base.setHours(hours, minutes, 0, 0);
  }

  return base.toISOString();
};

const finish = async () => {
  const isRecurring = servey.value.optionForRepeatEventStep === 2;
  const repeatOption = repeatTypes.value.find((el) => el.value === servey.value.optionRepeatSelected);
  const repeatType = isRecurring ? (repeatOption?.repeatType || 'none') : 'none';

  const payload = {
    petId: servey.value.choosedPetId,
    date: buildDate(),
    title: servey.value.title,
    description: servey.value.description,
    allDay: servey.value.selectedTimeTypes === 2,
    endTime: servey.value.selectedTimeTypes === 1 ? (servey.value.choosedTimeEnd || null) : null,
    repeatType,
    repeatDays: repeatType === 'custom_days' ? servey.value.selectedDays : null,
  };

  const response = eventId.value
    ? await updateEvent({ eventId: eventId.value, ...payload })
    : await createEvent(payload);
  const { success } = response || {};

  if (success) {
    FinishREF.value.openModal();
    return;
  }

  errorToast({ title: t('common.error'), description: t('eventsWizard.saveError') })
};

const initData = async () => {
  const res = await getAnimals()
  animals.value = res.animals

  if (eventId.value) {
    const { events } = await getEvents()
    const existing = events?.find((el) => el.id === eventId.value)

    if (existing) {
      servey.value.choosedPetId = existing.pet_id
      servey.value.title = existing.title
      servey.value.description = existing.description || ''
      servey.value.choosedDate = { date: existing.date, title: new Date(existing.date).toLocaleDateString('ru-RU') }
      servey.value.selectedTimeTypes = existing.all_day ? 2 : 1
      if (!existing.all_day) {
        const date = new Date(existing.date)
        servey.value.choosedTimeStart = `${String(date.getHours()).padStart(2, '0')}:${String(date.getMinutes()).padStart(2, '0')}`
        servey.value.choosedTimeEnd = existing.end_time || ''
      }
    }
  }

  loading.value = false;
}

onMounted(async () => {
  initData()
});
</script>

<style scoped lang="scss">
.hidden {
  pointer-events: none;
  visibility: hidden;
}

.mb-20 {
  margin-bottom: 20px;
}

.footer {
  padding: 10px;
}

.mb {
  margin-bottom: 10px;
}

.event-page {
  display: flex;
  flex-direction: column;
  height: 100vh;

  &__select {
    background: #ffffff;
    border: 1px solid #e8eafc;
    border-radius: 20px;
    font-weight: 500;
    font-size: 16px;
    padding: 0 20px;
    display: flex;
    align-items: center;
    min-height: 70px;
    color: #6b7090;
    margin-bottom: 10px;

    &:last-child {
      margin-bottom: 0;
    }

    &.active {
      background: #8ac926;
      color: #ffffff;
    }
  }

  &__date-text {
    &.choosed {
      color: #555555;
      font-weight: 600;
    }
  }

  &__date-img {
    filter: grayscale(100%);

    &.choosed {
      filter: grayscale(0%);
    }
  }

  &__date-wrapp {
    display: flex;
    justify-content: space-between;
    background: #ffffff;
    border: 1px solid #e8eafc;
    border-radius: 20px;
    height: 60px;
    align-items: center;
    padding: 0 20px;
    color: #999999;
  }

  &__pets {
    display: grid;
    gap: 10px;
  }

  &__empty {
    text-align: center;
    color: #6B7090;
    font-size: 15px;
    font-weight: 500;
    margin-top: 40px;
  }

  &__pets-item {
    border-radius: 26px;
    background: #FFF;
    box-shadow: 0px 4px 10px 0px rgba(0, 0, 0, 0.05);
    border: 2px solid transparent;
    padding: 10px;
    display: grid;
    grid-template-columns: 60px 1fr;
    align-items: center;
    gap: 15px;
    cursor: pointer;
    transition: border-color .2s ease;

    &.active {
      border-color: #5B43EF;
    }
  }

  &__pets-img {
    width: 60px;
    height: 60px;
    border-radius: 20px;
    background: #F2F8FF;
    object-fit: cover;
  }

  &__pets-body {
    display: grid;
    gap: 6px;
    min-width: 0;
  }

  &__pets-name {
    color: #5B5F7C;
    font-size: 15px;
    font-weight: 700;
    line-height: 14px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  &__pets-breed {
    color: #8E92AF;
    font-size: 14px;
    font-weight: 500;
    line-height: 14px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .loader-container {
    display: flex;
    justify-content: center;
    align-items: center;
    height: calc(100vh - 81px);
  }

  &__header {
    padding: 25px 30px 25px 30px;
    border-bottom: 1px solid #e7e7e7;

    &__icon {
      cursor: pointer;
      width: 16px;
      height: 14px;
      margin-right: 20px;
    }

    &__avatar {
      width: 28px;
    }
  }

  &__title {
    font-weight: 700;
    margin-bottom: 30px;
    font-size: 24px;
    line-height: 28px;
    text-align: center;
    margin-top: 20px;
    color: #645c56;
  }

  &__main {
    flex-grow: 1;
    overflow-y: scroll;
    -webkit-overflow-scrolling: touch;
    padding: 10px;
    display: flex;
    flex-direction: column;

    &__warning {
      position: relative;
      background: yellow;
      padding: 20px 40px 20px 20px;
      border-radius: 7px;
      color: white;
      font-weight: 500;
      font-size: 14px;

      &__close {
        cursor: pointer;
        width: 10px;
        height: 10px;
        position: absolute;
        right: 15px;
        top: 15px;
      }
    }
  }

  .fade-enter-active,
  .fade-leave-active {
    transition: opacity 0.3s ease;
  }

  .fade-enter-from,
  .fade-leave-to {
    opacity: 0;
  }
}
</style>
